import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// constants
import LocalStrings from '../../languages';

// files
import FourZeroFourPNG from '../../assets/img/placeholders/404.png';

const PageNotFound = props => {
  const { session, deviceSize } = props;

  return (
    <div
      className="no-content-message"
      style={{ height: deviceSize.height - 137 }}
    >
      <div>
        <img
          src={FourZeroFourPNG}
          className="mr-4 mb-4"
          style={{ height: 150, width: 150 }}
        />
        <div className="no-content-text">{LocalStrings.no_page}</div>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    session: state.session,
    deviceSize: state.deviceSize
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PageNotFound);
